module.exports = __webpack_public_path__ + "static/media/dripicons-v2.11fc83ae.woff";